import util from "./util";
export const userMixins = {
  data() {
    return {
      util,
      emailRules: [
        v => {
          if (!v || util.EMAIL_REGEX.test(v)) {
            return true;
          }
          return this.$t("validation.invalid", [
            this.$t("modules.users.email")
          ]);
        }
      ],
      passwordRegexRules: [
        v => {
          if (!v || util.PASSWORD_REGEX.test(v)) {
            return true;
          }
          return [
            this.$t("modules.users.passwordConstraints.characterLength"),
            this.$t("modules.users.passwordConstraints.uppercase"),
            this.$t("modules.users.passwordConstraints.lowercase"),
            this.$t("modules.users.passwordConstraints.digit"),
            this.$t("modules.users.passwordConstraints.specialCharacter")
          ].join("<br>");
        }
      ]
    };
  }
};
